export default __webpack_public_path__ + "static/media/juanma-freire-1.7e6751ea.png";